import {
  AppClientAddAddress,
  AppClientGetCustomer,
} from "Constants";
import {
  CustomerAddress,
  CustomerAddressAPI,
  ResultsDTO
} from "Types";
import { setLoggedIn } from "State/actions";
import { AppClientGetCustomerLoyaltyResponse, AppClientGetCustomerResponse } from "features/customer/interfaces/customer-api.interface";
import { store } from "State/store";

import { ApiService } from "./ApiService";

export const CustomerApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    customer: builder.query<AppClientGetCustomerResponse, void>({
      query: () => ({
        url: AppClientGetCustomer,
        method: "GET",
      }),
      onQueryStarted: async (args, { queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch (err: any) {
          if (err.error.status === 401) {
            // notifications.show({
            //     id: 'token-expired',
            //     withCloseButton: true,
            //     autoClose: 5000,
            //     // title: "Token Expired",
            //     message: '',
            //     // message: 'Please Login',
            //     loading: false,
            // });
            localStorage.removeItem("cart");
            store.dispatch(setLoggedIn(false));
          }
        }
      },
    }),
    addAddress: builder.mutation<ResultsDTO<CustomerAddressAPI>, CustomerAddress>({
      query: (address) => ({
        url: AppClientAddAddress,
        method: "POST",
        body: {
          ...address,
        },
      }),
      invalidatesTags: ["Addresses"],
      // onQueryStarted: async (args, { queryFulfilled }) => {
      //     try {
      //         await queryFulfilled;
      //     } catch (err: any) {
      //         if (err.error.status === 401) {
      //             notifications.show({
      //                 id: 'token-expired',
      //                 withCloseButton: true,
      //                 autoClose: 5000,
      //                 title: "Token Expired",
      //                 message: 'Please Login',
      //                 loading: false,
      //             });
      //             localStorage.removeItem("cart");
      //             store.dispatch(setLoggedIn(false));
      //             console.error(err);
      //         }
      //     }
      // },
    }),
    getAllAddress: builder.query<ResultsDTO<CustomerAddressAPI[]>, null>({
      query: () => ({
        url: `/customer/address`,
        method: "GET",
      }),
      providesTags: ["Addresses"],
    }),
    getBillingAddress: builder.query<ResultsDTO<CustomerAddressAPI>, { plant: string }>({
      query: ({ plant }) => ({
        url: `/customer/billing-address`,
        method: "GET",
        params: { plant },
      }),
      providesTags: ["Addresses"],
      onQueryStarted: async (args, { queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch (err: any) {
          if (err.error.status === 401) {
            localStorage.removeItem("cart");
            store.dispatch(setLoggedIn(false));
          }
        }
      },
    }),
    updateBillingAddress: builder.mutation<
      ResultsDTO<boolean>,
      {
        addr1: string;
        addr2: string;
        addr3: string;
        addr4: string;
        country: string;
        customerName: string;
        email: string;
        mobileNumber: string;
        pinCode: string;
        state: string;
      }
    >({
      query: (customerBillingAddressDTO) => ({
        url: `/customer/billing-address`,
        method: "POST",
        body: customerBillingAddressDTO,
      }),
      invalidatesTags: ["Addresses"],
      onQueryStarted: async (args, { queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch (err: any) {
          if (err.error.status === 401) {
            localStorage.removeItem("cart");
            store.dispatch(setLoggedIn(false));
          }
        }
      },
    }),

getCustomerLoyalty: builder.query<AppClientGetCustomerLoyaltyResponse, void>({
  query: () => ({
    url: "/loyalty-points/get-customer-loyalty",
    method: "GET",
    headers: {
      Origin: "origin", 
    },
  }),
}),
 getCustomerProfile: builder.query<ResultsDTO<any>, void>({
      query: () => ({
        url: "/customer/profile",
        method: "GET",
      }),
      providesTags: ["Profile"],
      onQueryStarted: async (_args, { queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch (err: any) {
          if (err?.error?.status === 401) {
            localStorage.removeItem("cart");
            store.dispatch(setLoggedIn(false));
          }
        }
      },
    }),

   updateCustomerProfile: builder.mutation<
      ResultsDTO<boolean>,
      {
        customerName: string;
        mobileNumber: string;
        email: string;
        addr1: string;
        addr2: string;
        addr3: string;
        addr4: string;
        state: string;
        country: string;
        pinCode: string;
        gender?: string;
      }
    >({
      query: (body) => ({
        url: "/customer/update-profile",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Profile", "Addresses"],
      onQueryStarted: async (_args, { queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch (err: any) {
          if (err?.error?.status === 401) {
            localStorage.removeItem("cart");
            store.dispatch(setLoggedIn(false));
          }
        }
      },
    }),
    deleteCustomerAddress: builder.mutation<ResultsDTO<boolean>, number>({
      query: (id) => ({
        url: `/customer/address/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Addresses"],
    }),
  }),
});

export const {
  useCustomerQuery,
  useLazyCustomerQuery,
  useAddAddressMutation,
  useGetAllAddressQuery,
  useGetBillingAddressQuery,
  useUpdateBillingAddressMutation,
  useGetCustomerLoyaltyQuery,
  useLazyGetCustomerLoyaltyQuery,
  useGetCustomerProfileQuery,
  useUpdateCustomerProfileMutation,
  useDeleteCustomerAddressMutation,
} = CustomerApiSlice;
